// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fe3b160c","455":"7748a81e","692":"93b296bc","977":"503d0afd"}[chunkId] + ".chunk.js";
};